<template>
  <div id="appRoot">
    <v-app id="inspire" class="app">
      <PageHeader />
      <RouterView />
      <v-dialog v-model="delDialog" persistent max-width="320">
        <v-card>
          <v-card-title class="subheading">Xác nhận</v-card-title>
          <v-card-text>{{ delMessage || 'Bạn có chắc chắn muốn huỷ mục đã chọn?'}}</v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="darken-1" @click="delConfirmed">Đồng ý</v-btn>
            <v-btn color="red darken-1" @click="delDialog = false">Đóng</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-overlay :value="appLoading" z-index="999999">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-snackbar transition="slide-x-transition" :timeout="snackbar.timeout ? snackbar.timeout : 5000" :color="snackbar.color" v-model="snackbar.show" bottom left multi-line rounded>
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar.show = false"
          >
            X
          </v-btn>
        </template>
      </v-snackbar>
    </v-app>
  </div>
</template>
<script>
import AppEvents from "./event";
import { RouterView } from "vue-router";
import PageHeader from "./components/PageHeader.vue";
import { loadScript } from "vue-plugin-load-script";
import Vue from "vue";
import _ from 'lodash';
export default {
  components: {
    PageHeader
  },
  data() {
    return {
      dialogMessage: true,
      delMessage: "",
      delDialog: false,
      delId: 0,
      rightDrawer: false,
      isConfirm: false,
      snackbar: {
        timeout : 5000,
        show: false,
        text: "",
        color: ""
      },
      appLoading: false
    }
  },
  computed: {
    showCustomerMessage() {
      return Vue.$cookies.get('showCustomerMessage');
    }
  },
  methods: {
    delConfirmed() {
      this.delDialog = false;
      this.$root.$emit('CONFIRMED_REMOVE_DATA', this.delId);
    }
  },
  created() {
    AppEvents.forEach(item => {
      this.$root.$on(item.name, item.callback);
    });
    window.getApp = this;
    this.$root.$on('COMPONENT_LOADED', _.debounce(function () {
      // Vue.nextTick(() => { loadScript(`/assets/js/plugins.js?v=${Math.random().toString(36).slice(2)}`); });
      Vue.nextTick(() => { loadScript(`/assets/js/main.min.js?v=${Math.random().toString(36).slice(2)}`); });
    }, 500, {'leading': true, 'trailing': true}));
  },
};
</script>
